module.exports = __webpack_public_path__ + "javascriptPostit.svg?62abef9e6b40e607b2da1d1190afc1b8";